<template>
  <div class="left_content bsb">
    <div class="sidebar">
      <div class="sidebar_item "
           v-for="(item,ind) in list"
           :key="ind">
        <div class="sidebar_item_title flex aic jcb "
             @click="showChildren(item)"
             @mouseover="isMou = item.id"
             @mouseout="isMou = ''">
          <span class="sidebar_item_title_text"
                :class="{active: isShow === item.id}">{{item.title}}</span>
          <span class="footer_icon left_arrow"
                v-show="item.id !== 2"
                :class="{
                  down_arrow_active:isShow === item.id,
                  left_arrow_active:isMou === item.id}"></span>
        </div>
        <div class="sidebar_item_child  flex aic "
             :class="{active: isChild === child.prop}"
             v-show="item.show && item.id !== 2"
             v-for="(child,index) in item.children"
             :key="index"
             @click="changeChild(child)">
          {{child.name}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "ViewSidebar",
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {
    $route () {
      let type = this.$route.query.type;
      if (type === 'business') {
        this.list.forEach(e => {
          e.show = e.id === 2;
        });
        this.isShow = 2;
        this.isChild = '';
      } else {
        this.list.forEach(e => {
          e.children.forEach(v => {
            if (v.prop === type) {
              this.isShow = e.id;
              this.isChild = v.prop;
              e.show = true;
            }
          })
        })
      }
    }
  },
  data () {
    return {
      list: [
        {
          id: 1,
          title: '关于我们',
          show: false,
          children: [
            { name: '公司介绍', prop: 'company' },
            { name: '加入我们', prop: 'join' },
          ]
        },
        {
          id: 2,
          title: '商务合作',
          show: false,
          children: [
            { name: '内容合作', prop: 'business' },
            { name: '会员合作', prop: 'business' },
            { name: '渠道合作', prop: 'business' },
            { name: '广告合作', prop: 'business' },
          ]
        },
        {
          id: 3,
          title: '服务',
          show: false,
          children: [
            { name: '用户协议', prop: 'user_protocol' },
            { name: '隐私政策', prop: 'privacy' },
            { name: '会员协议', prop: 'vip_protocol' },
            { name: '帮助与反馈', prop: 'help' },
            { name: '侵权举报与投诉', prop: 'tort' },
          ]
        },
      ],
      isShow: '',
      isChild: '',
      isMou: '',
    };
  },
  methods: {
    showChildren (item) {
      let val = this.list.find(e => e.id === item.id);
      if (this.isShow === item.id) {
        this.list.find(e => e.id === item.id).show = !val.show;
        this.isShow = '';
        this.isChild = '';
      } else {
        this.isShow = item.id;
        this.list.forEach(e => {
          e.show = this.isShow === e.id;
        });
        //子级
        if (val.children.length) {
          this.isChild = val.children[0].prop;
          this.$router.push({
            path: '/footer/details',
            query: { type: this.isChild, }
          });
        } else {
          item.id === 2 && this.$router.push({
            path: '/footer/details',
            query: { type: 'business' }
          });
        }
      }
    },
    changeChild (item) {
      if (item.prop === 'help' && !this.userInfo.uid) {
        this.ToLogin();
      } else {
        this.$router.push({
          path: '/footer/details',
          query: { type: item.prop, id: item.id }
        });
        this.isChild = item.prop;
      }
    },
  },
  created () {
    if (this.$route.query.type) {
      let type = this.$route.query.type;
      this.list.forEach(e => {
        if (e.children.length) {
          e.children.forEach(val => {
            if (val.prop === type) {
              this.isChild = type;
              this.isShow = e.id;
              e.show = !e.show;
            }
          })
        } else {
          if (type === 'business') {
            this.isShow = 2;
            this.isChild = '';
            e.show = e.id === 2;
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '../../assets/less/function';
.left_content {
  padding: 36px 20px;
  width: 287px;
  height: 639px;
  background: #fff;
  border-radius: 8px;
}

.footer_icon {
  .spirit(url(../../assets/images/footer/footer_icon.png));
  &.left_arrow {
    &:after {
      width: 8px;
      height: 13px;
      background-position: -61px -3px;
    }
  }
  &.left_arrow_active {
    &:after {
      width: 8px;
      height: 13px;
      background-position: -72px -3px;
    }
  }
  &.down_arrow_active {
    &:after {
      width: 13px;
      height: 8px;
      background-position: -86px -6px;
    }
  }
}

.sidebar {
  color: #959595;
  .sidebar_item {
    width: 247px;
    .sidebar_item_title {
      font-size: 16px;
      height: 44px;
      &:hover {
        color: #1177ff;
        cursor: pointer;
      }
    }
    .sidebar_item_child {
      width: 247px;
      height: 44px;
      padding-left: 16px;
      font-size: 14px;
      &:hover {
        color: #1177ff;
        cursor: pointer;
      }
    }
  }
}

.active {
  color: #1177ff;
}
</style>